<template>
<v-dialog max-width="600px" v-model="addBookingDialog">
    <v-btn flat slot="activator" class="success" v-if="buttonType==='large'">Ny Reservation</v-btn>
    <v-btn flat fab small slot="activator" class="success" v-if="buttonType==='round'">+</v-btn>
    <v-card>
        <v-card-title>
            <h2>Tilføj ny booking</h2>
            <v-layout align-center justify-end row>
                <v-flex xs2 my-1 white--text>
                    <v-btn flat icon color="black" @click.stop="addBookingDialog = !addBookingDialog">
                        <v-icon>clear</v-icon>
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-card-title>
        <v-card-text>
            <v-form class="px-3" ref="form">
                <v-flex xs12>
                    <div class="caption grey--text">Tidspunkt</div>
                </v-flex>
                <v-menu>
                    <v-btn slot="activator">
                        <v-icon>date_range</v-icon> {{formattedDate}}
                    </v-btn>
                    <v-date-picker v-model="dateSelected" :min="dateCurrent" :max="maxDate"></v-date-picker>
                </v-menu>
                <v-spacer></v-spacer>
                <v-menu :close-on-content-click="false" v-model="timeStartShow" offset-y lazy transition="scale-transition" max-width="290px" min-width="290px">
                    <v-btn slot="activator">
                        <v-icon>access_time</v-icon>
                        Tid start: {{timeStart}}
                    </v-btn>
                    <v-time-picker v-model="timeStart" :allowed-minutes="allowedStep" min="7:00" max="20:" format="24hr"></v-time-picker>
                </v-menu>
                <v-menu :close-on-content-click="false" v-model="timeEndShow" offset-y lazy transition="scale-transition" max-width="290px" min-width="290px">
                    <v-btn slot="activator">
                        <v-icon>timelapse</v-icon>
                        Tid slut: {{timeEnd}}
                    </v-btn>
                    <v-time-picker v-model="timeEnd" :allowed-minutes="allowedStep" min="7:00" max="20:" format="24hr"></v-time-picker>
                </v-menu>
                <v-spacer></v-spacer>
                <v-layout row wrap justify-center justify-space-around>
                    <v-flex xs12>
                        <div class="caption grey--text">Hest</div>
                    </v-flex>
                    <v-flex xs12 v-if="horses.filter(horse => { return horse.userid === profile.id}).length === 0 || typeof horses.filter(horse => { return horse.userid === profile.id}) === 'undefined' " mb-2>
                        <div class="red--text">Opret en hest under min side!</div>
                    </v-flex>

                    <v-radio-group v-model="horseid" xs6 v-for="horse in horses.filter(horse => { return horse.userid === profile.id})" :key="horse.id">
                        <v-radio :value="horse.id" :label="horse.name"></v-radio>
                    </v-radio-group>
                    <v-spacer></v-spacer>
                    <v-flex xs12>
                        <div class="caption grey--text">Fold</div>
                    </v-flex>
                    <v-flex xs12>
                        <v-alert v-model="$store.getters.showAlertBooking" color="error">
                            {{$store.getters.message}}
                        </v-alert>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs2 sm1 md1 v-for="resource in resources" :key="resource.id">
                        <v-btn @click="$store.dispatch('setResid', resource.id)" small flat fab :style="[{'background': `${selected(resource.id,$store.getters.resid) }`},{'color': `${selectedText(resource.id,$store.getters.resid) }`}]">{{resource.name}}</v-btn>
                    </v-flex>
                </v-layout>
                <v-spacer></v-spacer>
                <v-btn flat class="success mx-0 mt-3" @click="submit" :loading="loading">Reserver fold</v-btn>
            </v-form>
            <v-container class="my-1">
                <v-flex xs12>
                    <div class="grey--text">Reservationer</div>
                </v-flex>
                <v-divider></v-divider>
                <v-flex xs12 mt-2>
                    <div class="caption grey--text" v-if="noBookings < 1">Der er ingen reservationer endnu på denne fold.</div>
                </v-flex>

                <Bookings />
            </v-container>
        </v-card-text>
    </v-card>
</v-dialog>
</template>

<script>
import format from 'date-fns/format'
import Bookings from '@/components/Bookings';

export default {
    components: {

        Bookings
    },
    data() {
        return {
            timeStartShow: false,
            addBookingDialog: false,
            timeEndShow: false,
            timeStart: '',
            timeEnd: '',
            horseid: '',
            inputRules: [
                v => v.length >= 1 || 'Input skal udfyldes'
            ],
            loading: false,
        }
    },
    props: {
        buttonType: String
    },
    computed: {

        userSession() {
            if (this.$store.getters.authUser)
                return true
            else
                return false
        },

        userid() {
            if (this.$store.getters.authUser === null || this.$store.getters.authUser == null || typeof this.$store.getters.authUser === 'undefined') {
                return ''
            } else {
                return this.$store.getters.authUser.uid
            }

        },
        profile() {
            return this.$store.getters.profile
        },
        users() {
            return this.$store.getters.users
        },

        bookings() {
            return this.$store.getters.bookings
        },
        horses() {
            return this.$store.getters.horses
        },
        resources() {
            return this.$store.getters.resources
        },
        formattedDate() {
            
            return this.$store.getters.dateSelected ? format(this.$store.getters.dateSelected, 'DD MMM YYYY') : ''
        },
        dateSelected: {
            //getter
            get: function () {
                return this.$store.getters.dateSelected
            },
            // setter
            set: function (newValue) {
                this.$store.dispatch('setDateSelected', newValue);
            }          
        },
        dateCurrent() {
            return this.$store.getters.dateCurrent
        },
        maxDate() {
            return this.$store.getters.maxDate
        },
        noBookings() {
            return this.bookings.filter(booking => {
                return booking.resid === this.$store.getters.resid && booking.date === this.$store.getters.dateSelected
            }).length
        }
    },
    created: function () {

    },
    watch: {
        timeStart: function () {
            if (this.timeStart !== '' && this.timeEnd === '') {
                this.timeStartShow = false
                this.timeEndShow = true
            } else {
                this.timeStartShow = false
            }
        },
        timeEnd: function () {
            if (this.timeEnd !== '') {
                this.timeEndShow = false
            }
        }
    },
    methods: {

        resourceName(resources, resid) {
            let resource = []
            resource = this.resourceById(resources, resid)
            if (typeof resource !== 'undefined') {
                return resource.name
            } else {
                return ''
            }
        },
        resourceById(resources, residToFind) {
            const resource = resources.find(function (resource) {
                return resource.id === residToFind;
            })

            return resource
        },
        horseName(horses, horseid) {
            let horse = []
            horse = this.horseById(horses, horseid)
            if (typeof horse !== 'undefined') {
                return horse.name
            } else {
                return 'Ukendt'
            }
        },
        horseById(horses, horseidToFind) {
            const horse = horses.find(function (horse) {
                return horse.id === horseidToFind;
            })
            return horse
        },
        userName(users, userid) {
            let user = []
            user = this.userById(users, userid)
            if (typeof user !== 'undefined') {
                return user.name
            } else {
                return ''
            }
        },
        userById(users, useridToFind) {
            const user = users.find(function (user) {
                return user.id === useridToFind;
            })
            return user
        },
        submit() {
            if (this.$refs.form.validate()) {

                const booking = {
                    date: this.$store.getters.dateSelected,
                    horseid: this.horseid,
                    resid: this.$store.getters.resid,
                    timeStart: this.timeStart,
                    timeEnd: this.timeEnd,
                    userid: this.$store.getters.profile.id
                }

                //this.$store.dispatch('addNewBooking', {booking: booking, profile: this.profile, vm: this })   
                this.$store.dispatch('addNewBooking', {
                    booking: booking,
                    vm: this
                })

            }
        },
        selected: function (id1, id2) {
            if (id1 === id2) {
                return '#1976d2'
            } else
                return ''
        },
        selectedText: function (id1, id2) {
            if (id1 === id2) {
                return 'white'
            } else
                return ''
        },
        allowedStep: m => m % 30 === 0
    }
}
</script>
